var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-top-area"},[_c('div',{staticClass:"go-top-wrap"},[_c('div',{staticClass:"go-top-btn-wrap"},[_c('div',{ref:"btn",class:['go-top','go-top-btn',_vm.active ? 'active' : ''],on:{"click":_vm.gotop}},[_c('i',{staticClass:"iconfont icondownarrow"}),_vm._v(" "),_c('i',{staticClass:"iconfont icondownarrow"})])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d10f024","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layout/components/goTop.vue
// module id = null
// module chunks = 